import { Layout } from "antd";
import { StyledPageContent } from "./style";
import {
  LayoutContentProps,
  LayoutHeaderProps,
  LayoutProps,
  LayoutSiderProps,
} from "./type";

function AntLayout(props: LayoutProps) {
  return <Layout {...props} />;
}
function AntLayoutSider(props: LayoutSiderProps) {
  return <Layout.Sider {...props} />;
}
function AntLayoutHeader(props: LayoutHeaderProps) {
  return <Layout.Header {...props} />;
}
function AntLayoutContent(props: LayoutContentProps) {
  return <StyledPageContent {...props} />;
}

export {
  AntLayoutContent as Content,
  AntLayoutHeader as Header,
  AntLayout as Layout,
  AntLayoutSider as LayoutSider,
};
